import React, { useState } from "react";
import { useLocale } from './LocaleProvider';

export default function PasswordAuth({ onAuthenticated, onOtp, showOtp = true }) {
  const { locale } = useLocale();
  const spanish = locale === 'es';
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setMessage("");
    try {
      const response = await fetch("/api/auth/sign-in", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(spanish ? 'Correo o contraseña incorrectos.' : (payload.error || "E-mail ou senha inválidos."));
      const authenticatedUser = payload.user || { email: email.trim().toLowerCase() };
      // Só o id interno identifica o usuário no analytics; sem id, não há identify (nunca o e-mail).
      if (authenticatedUser.id) window.eidocAnalytics?.identify(authenticatedUser.id, { product: 'minimental', auth_method: 'password' });
      window.eidocAnalytics?.capture('user_signed_in', { auth_method: 'password' });
      onAuthenticated?.(authenticatedUser);
    } catch (error) {
      setMessage(error.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div>
      <form onSubmit={submit}>
        <label className="block text-sm font-bold text-[var(--primary)]" htmlFor="password-email">{spanish ? 'Correo electrónico' : 'E-mail'}</label>
        <input id="password-email" required type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} placeholder={spanish ? 'tu@correo.com' : 'seu@email.com'} className="input-field mt-2" />
        <label className="mt-4 block text-sm font-bold text-[var(--primary)]" htmlFor="password-login">{spanish ? 'Contraseña' : 'Senha'}</label>
        <input id="password-login" required type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder={spanish ? 'Tu contraseña' : 'Sua senha'} className="input-field mt-2" />
        <button disabled={busy} className="mt-4 min-h-11 w-full rounded-xl bg-[var(--accent)] p-3 font-bold text-[var(--on-accent)] disabled:opacity-60">{busy ? (spanish ? 'Iniciando sesión…' : 'Entrando…') : (spanish ? 'Iniciar sesión' : 'Entrar')}</button>
      </form>
      {message && <p role="alert" className="mt-4 text-sm text-[var(--text-muted)]">{message}</p>}
      {showOtp && <button type="button" onClick={onOtp} className="mt-4 min-h-11 w-full text-sm text-[var(--primary)] underline">{spanish ? 'Entrar con un código de un solo uso' : 'Entrar sem senha por código OTP'}</button>}
    </div>
  );
}
